<template>
    <div class="home-actions-section" v-if="indexPage != null">
        <div class="container" v-if="!isMobileChecker">
            <div class="action-btn-prev slider-btn">
                <svgIcon name="arrow-left" class="icon-left-arrow"/>
            </div>
            <div class="actions-carousel">
                <swiper :options="swiperOption" ref="promoCarousel">
                    <swiper-slide v-for="(slide, index) in indexPage.main_actions" :key="index">
                        <a href="#" @click.prevent>
                            <div class="slide-info">
                                <div class="slide-icon"><img :src="slide.icon" alt=""></div>
                                <div class="slide-desc">
                                    <strong>{{ slide.title }}</strong>
                                    <p v-html="slide.desc"></p>
                                </div>
                            </div>
                        </a>
                    </swiper-slide>
                </swiper>
                <!-- <div class="swiper-pagination promo-pagination"></div> -->
            </div>
            <div class="action-btn-next slider-btn">
                <svgIcon name="arrow-right" class="icon-right-arrow"/>
            </div>
        </div>
        <div class="mobile-container" v-if="isMobileChecker">
            <div class="item" v-for="(item, index) in indexPage.main_actions">
                <div class="item-icon"><img :src="item.icon" alt=""></div>
                <div class="item-desc">
                    <strong>{{ item.title }}</strong>
                    <p v-html="item.desc"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-actions-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                dataArr: null,
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    slidesPerView: 3,
                    spaceBetween: 25,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    // autoplay: {
                    //     delay: 3000,
                    //     disableOnInteraction: true,
                    // },
                    navigation: {
                        nextEl: '.action-btn-next',
                        prevEl: '.action-btn-prev',
                    },
                    breakpoints: {
                        // when window width is <= 900px
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                    }
                    // pagination: {
                    //     el: '.promo-pagination',
                    //     type: 'bullets',
                    //     clickable: true,
                    // },
                },
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-actions.scss';
    @import '@/styles/components/home-page/respond/home-actions-respond.scss';
    // @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>